module.exports = __webpack_public_path__ + "img/ic_rename.7b050311.svg";